import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { IRuleMySuffix } from 'src/app/shared/model/rule-my-suffix.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { RuleMySuffixService } from './rule-my-suffix.service';

@Component({
    selector: 'jhi-rule-my-suffix-delete-dialog',
    templateUrl: './rule-my-suffix-delete-dialog.component.html'
})
export class RuleMySuffixDeleteDialogComponent {
    rule: IRuleMySuffix;

    constructor(private ruleService: RuleMySuffixService, public activeModal: NgbActiveModal, private eventManager: JhiEventManager,
    private languageChangeService: LanguageChangeService,private activatedRoute: ActivatedRoute
    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.ruleService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'ruleListModification',
                content: 'Deleted an rule'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-rule-my-suffix-delete-popup',
    template: ''
})
export class RuleMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(private activatedRoute: ActivatedRoute, private router: Router, private modalService: NgbModal) {}

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ rule }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(RuleMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.rule = rule;
                this.ngbModalRef.result.then(
                    result => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    },
                    reason => {
                        this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
